/* TBET — header logo state controller (2 states)
   State 01: black wordmark, transparent (default at top)
   State 02: black mark, transparent (when scrolled past 120px)
*/
(function () {
  const SCROLL_THRESHOLD = 120;

  const cube = document.querySelector('[data-tbet-logo-cube]');
  if (!cube) return;

  let inState02 = false;

  function update() {
    const past = window.scrollY > SCROLL_THRESHOLD;
    if (past !== inState02) {
      inState02 = past;
      cube.classList.toggle('is-state-02', past);
    }
  }

  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
